import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';
import showLoader from '@components/loader';

export const getDeviceByCategory = createAsyncThunk('emphoraDeviceSlice/getDevice', async (data) => {
    try {
        let newData = {
            id: data.id,
            skip: data.skip,
            take: data.take
        };

        if (data.search) {
            newData.search = data.search;
        }

        let response = await axios.post('/category-device', newData, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createEmphoraDevice = createAsyncThunk('emphoraDeviceSlice/createEmphoraDevice', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/emphora-device', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Device created successfully.');
        // dispatch(getDeviceCategory());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateEmphoraDevice = createAsyncThunk('emphoraDeviceSlice/updateEmphoraDevice', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/emphora-device/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Device updated successfully.');
        // dispatch(getChallanType());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getDeviceDetails = createAsyncThunk('emphoraDeviceSlice/getDeviceDetails', async (data) => {
    try {
        let response = await axios.post('/emphora-device/with-filters', data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
            // loader: false
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteDevice = createAsyncThunk('emphoraDeviceSlice/deleteDevice', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/emphora-device/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Device deleted successfully');
        // dispatch(getDriver());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getDevice = createAsyncThunk('emphoraDeviceSlice/getDevice', async (id) => {
    try {
        showLoader(true);
        let response = await axios.get('/device/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateDeviceStatus = createAsyncThunk('emphoraDeviceSlice/updateDeviceStatus', async (id, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/emphora-device/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const emphoraDeviceSlice = createSlice({
    name: 'emphoraDeviceSlice',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getDeviceByCategory.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
    }
});

export default emphoraDeviceSlice.reducer;
